import { Fragment } from "react";
import { Box as MuiBox, Grid as MuiGrid } from "@mui/material";

import { Breadcrumbs, PageHeader, Spinner } from "@dzambalaorg/mui-page-layout";
import { RichTextDisplay } from "@dzambalaorg/mui-rte";
import type { ICraft } from "@framework/types";
import { useFetchData } from "@dzambalaorg/react-hooks";

import { CraftTransactions } from "./transactions";
import { CraftItemPanel } from "../craft-item-panel";
import { StyledDescription, StyledImageList, StyledImageListItem } from "../../../../../../components/styled";

export const CraftItem = () => {
  const { data, isLoading, isError } = useFetchData<ICraft>("/recipes/craft");

  if (isLoading) {
    return <Spinner />;
  }

  if (isError || !data) {
    // TODO - [AFTER ALL REFACTORING] - add universal no data component
    return <div>No data</div>;
  }

  const componentsLength = data.item?.components.length;

  // Should never happen
  if (!componentsLength) {
    return null;
  }

  return (
    <Fragment>
      <Breadcrumbs
        path={["dashboard", "recipes", "recipes.craft"]}
        data={[{}, {}, { title: data.item?.components.map(comp => comp.template?.title).join(" + ") }]}
      />

      <PageHeader
        message="pages.recipes.craft.title"
        data={{ title: data.item?.components.map(comp => comp.template?.title).join(" + ") }}
      />

      <MuiGrid container>
        <MuiGrid size={{ xs: 12, sm: 9 }}>
          <StyledImageList $count={data.item?.components.length || 1}>
            {data.item?.components.map(component => {
              return (
                <StyledImageListItem key={component.template!.id}>
                  <MuiBox component="img" src={component.template!.imageUrl} alt={component.template!.title} />
                </StyledImageListItem>
              );
            })}
          </StyledImageList>
        </MuiGrid>
        <MuiGrid size={{ xs: 12, sm: 3 }}>
          <CraftItemPanel craft={data} />
        </MuiGrid>
      </MuiGrid>

      <StyledDescription>
        <RichTextDisplay data={data.item?.components[0].template!.description} />
      </StyledDescription>

      {data.id ? <CraftTransactions craft={data} /> : null}
    </Fragment>
  );
};
